export default __webpack_public_path__ + "static/media/share.563e5ad5.svg";